import { useHttpClient } from "@/common/api/httpClient";
import { storeToRefs } from "pinia";
import type { AuditResponse } from "shared/audit/api/auditResponse";
import type { Translations } from "shared/translations/domain/translations";
import { useLanguageStore } from "shared/translations/stores/languageStore";

export interface AuditRequest {
  id: string;
}

export interface AuditApiOptions {
  url: string;
  translateTitle: (translations: Translations) => string;
  translateError: (translations: Translations) => string;
}

export interface AuditApiTranslations {
  name: string;
  error: string;
}

export interface AuditResult {
  ok: true;
  audit: AuditResponse;
}

export function useAuditApi(options: AuditApiOptions) {
  const httpClient = useHttpClient();
  const languageStore = useLanguageStore();
  const { translations } = storeToRefs(languageStore);

  return {
    execute
  };

  async function execute(action: AuditRequest) {
    const headers = httpClient.defaultHeaders();
    const request = new Request(httpClient.siteUrl(`audit/${options.url}/${action.id}`), {
      headers
    });

    const title = options.translateTitle(translations.value);
    const error = options.translateError(translations.value);

    const response = await httpClient.action<AuditResult>(request, {
      title: title,
      errorTitle: error,
      async processOk(response) {
        const audit = await response.json() as AuditResponse;

        return {
          ok: true,
          audit: audit
        };
      },
    });

    return response;
  }
}
